import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { MensajeriaService } from '../../../../core/services';
import { Mensaje } from '../../../../core/models';

declare var $: any;

/**
 *  Componente para la visualización de un mensaje.
 *
 * @author lreverendo
 * @author aarodriguezo
 *
 * @version 01.02.0400
 * @since 01.02.0000
 */
@Component({
  selector: 'app-visualizacion-mensaje',
  templateUrl: './visualizacion-mensaje.component.html',
  styleUrls: ['../../mensajeria.component.css', './visualizacion-mensaje.component.css']
})
export class VisualizacionMensajeComponent implements OnInit, OnDestroy {
  @Input() permisoEnvioMensaje: Boolean;

  public mensaje: Mensaje = {
    id: '',
    pacienteNombre: '',
    pacienteApellido1: '',
    pacienteApellido2: '',
    cuerpo: '',
    asunto: '',
    leido: null,
    fechaEnvio: '',
    fechaLeido: '',
    profesionalNombre: '',
    profesionalApellido1: '',
    profesionalApellido2: '',
    profesionalServicio: '',
    profesionalCentro: ''
  };

  public recibido: Boolean = false;
  public mensajeCuerpoHTML: String = '';

  private sub: Subscription;

  constructor(private mensajeriaService: MensajeriaService) {}

  public ngOnInit(): void {
    // Subscripción al evento visualizarMensaje.
    this.sub = this.mensajeriaService.visualizarMensaje.subscribe(this.mostrarMensaje.bind(this));
  }

  public ngOnDestroy(): void {
    // Baja a la subscripción.
    this.sub.unsubscribe();
  }

  public nuevoMensaje(): void {
    this.mensajeriaService.crearNuevoMensaje.emit({ mensaje: this.mensaje });
  }

  private mostrarMensaje(data: { mensaje: Mensaje; recibido: boolean }): void {
    this.mensaje = { ...data.mensaje };

    // Generar la versión HTML enriquecida del cuerpo sin modificar el original
    this.mensajeCuerpoHTML = this.procesarMensajeParaMostrar(this.mensaje.cuerpo);

    this.recibido = data.recibido;
    $('#mensaje').modal('show');
  }
 
  private procesarMensajeParaMostrar(texto: string): string {
    if (!texto) return '';

    // Resaltar enlaces
    const conEnlaces = this.resaltarEnlaces(texto);

    return conEnlaces;
  }

  private resaltarEnlaces(texto: string): string {
    const urlRegex = /(\b(https?:\/\/|ftp:\/\/|www\.)[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return texto.replace(urlRegex, function (url) {
      let href = url;
      if (url.toLowerCase().startsWith('www.')) {
        href = 'http://' + url;
      }
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  }
}
